exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0;\n}\nli {\n  list-style-type: none;\n}\n#app {\n  margin: 0 !important;\n}\n.position_bottom {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n}\n.bg_page_color {\n  height: 100vh;\n  background-color: #f6f6f6;\n}\n.safe-top {\n  padding-top: constant(safe-area-inset-top);\n  padding-top: env(safe-area-inset-top);\n}\n.mint-swipe-indicator {\n  background-color: #fff !important;\n  opacity: 1 !important;\n}\n.mint-swipe-indicator.is-active {\n  width: 14px;\n  border-radius: 10px;\n  opacity: 1 !important;\n}\n.faq .el-dialog {\n  background-color: rgba(0, 0, 0, 0) !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0) !important;\n  webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0) !important;\n  margin-top: 8vh !important;\n  width: 55%;\n}\ndiv ::-webkit-scrollbar,\nul ::-webkit-scrollbar {\n  width: 0;\n  -webkit-transition: background-color 0.3s ease-in-out;\n  transition: background-color 0.3s ease-in-out;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/assets/less/style.less
// module id = +p8c
// module chunks = 1